/**
 * @file h5 微信分享的js
 * @author yaowu rockli
 */

import wx  from '../module/jweixin.js'


window.wxShare = {
    /**
     * url {string} 当前要分享的url "http://m.xcds.com.cn/"
     * noncestr {string} "6ba9a47b-d369-4c18-84aa-709d435ae853"
     * timestamp {string} 事件戳 "1479954114"
     * signature {string} 数字签名
     * @type {Object} 服务器端获取回来的微信分享数据
     */
    wxData: {},
    isWeiXin: function () {
        var ua = window.navigator.userAgent.toLowerCase();

        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        }
        else {
            return false;
        }
    },

    /**
     *    shareData {Object} 分享的配置参数
     *    shareList {Array} 要使用的分享功能列表
     *    title {string} 要分享的标题
     *    desc  {string} 要分享的描述
     *    link {string} 要分享的链接
     *    img  {string} 要分享的图标
     *    pyqSuc {Function} 分享到朋友圈成功回调
     *    pySuc {Function} 分享到朋友成功回调
     */
    deploy: function (shareData) {
        var data = this.wxData || {};

        //预留出来shareList 可以配置需要分享到什么的功能.
        var shareList = (shareData && shareData.shareList) || ['onMenuShareTimeline','onMenuShareAppMessage'];

        // 通过config接口注入权限验证配置
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: 'wx66417be81195f303', // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature,// 必填，签名，见附录1
            jsApiList: shareList
        });

        // 通过ready接口处理成功验证
        wx.ready(function () {
            //监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口

            var imgUrl = '';

            if (!shareData.img) {
                imgUrl = '//f4.jiejiatech.net/y16/0302/1531/00hzt_o.jpg';

                var img = document.getElementsByTagName('img')[0];

                if (img.height >= 100) {
                    imgUrl = img.src;
                }
            }

            var sd = {
                title: shareData.title || document.title,
                desc: shareData.desc || document.title,
                link: shareData.link || location.href,
                imgUrl: shareData.img || imgUrl,
                success:function(){
                    if (shareData && typeof shareData.pySuc === 'function') {
                        shareData.pySuc();
                    }
                }
            };

            // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
            wx.onMenuShareAppMessage(sd);

            // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
            wx.onMenuShareTimeline(sd);
        });
    },

    start: function (shareData) {
        var me = this;
        var wxDataHref = window.location.href;

        wxDataHref = wxDataHref.replace(/#.*/, '');

        // 获取签名
        $.ajax({
            url: "//is.xcds.com.cn/weixin/signature/",
            type: "GET",
            dataType: "jsonp",
            data: { "url": wxDataHref },
            success: function (data) {
                if (data.code === 0) {
                    me.wxData = data.data;
                    me.deploy(shareData);
                }
                else {
                    alert(data.msg);
                }
            }
        });
    },

    init: function () {
        if (this.isWeiXin()
            && typeof SER_DATA_WEIXIN !== 'undefined'
            && SER_DATA_WEIXIN['wx-share']) {
            this.start(SER_DATA_WEIXIN['wx-share']);
        }
    }
};

$(function () {
    window.wxShare.init();
})



// WEBPACK FOOTER //
// ./src/module/wx-share.js